// IntelliQ.Space - React Site with Custom Fonts and Styled Header

import { BrowserRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import posts from './posts.json';
import './index.css';
import OperaLanding from './pages/OperaLanding';
import AdBanner from './components/AdBanner';
import PopCashTrigger from './PopCashTrigger';
import IframeStackerTrigger from './IframeStackerTrigger';
import VideoLandingPage from './adultLander';


const Home = () => (
  <main className="raleway-content">
    <img src="https://alphatarget.com/wp-content/uploads/2024/05/artificial-intelligence-1.jpg" alt="IntelliQ Banner" style={{ width: '100%', maxHeight: '300px', objectFit: 'cover' , borderRadius:'8px'}} />
    <div style={{ padding: '2rem' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>Welcome to IntelliQ.Space</h1>
      <p style={{ marginTop: '0.5rem' }}>We explore psychology, intelligence, and human traits. Browse our latest articles below:</p>
      <ul style={{ marginTop: '1.5rem', listStyle: 'none', padding: 0 }}>
        {Object.entries(posts).map(([id, post]) => (
          <li key={id} style={{ marginBottom: '2rem' }}>
            <img
              src={post.thumbnail || 'https://url.com/default-thumb.jpg'}
              alt="Post Thumbnail"
              style={{ width: '100%', maxHeight: '180px', objectFit: 'cover', borderRadius: '8px' }}
            />
            <h2 style={{ marginTop: '1rem', marginBottom: '0.25rem' }}>
              <Link to={`/blog/${id}`} style={{ fontSize: '1.25rem', fontWeight: 600 }}>{post.title}</Link>
            </h2>
            <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>{post.date}</p>
          </li>
        ))}
      </ul>
    </div>
  </main>
);

const BlogPost = () => {
  const { postId } = useParams();
  const post = posts[postId];

  if (!post) return <main><p>Post not found.</p></main>;

  return (
    <main style={{ display: 'flex', gap: '2rem', padding: '1.5rem', flexWrap: 'wrap' }}>
      {/* Left: Main Article Content */}
      <div style={{ flex: '1 1 70%', minWidth: '300px' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>{post.title}</h1>
        <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1.5rem' }}>{post.date}</p>
        
        {post.sections.map((section, index) => (
          <div key={index} style={{ marginBottom: '2rem' }}>
            {section.image && (
              <img
                src={section.image}
                alt={section.heading || 'Section Image'}
                style={{ width: '100%', maxHeight: '240px', objectFit: 'cover', marginBottom: '1rem', borderRadius: '8px' }}
              />
            )}
            <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>{section.heading}</h2>
            <p>{section.content}</p>
          </div>
        ))}
      </div>

      {/* Right: Ad Sidebar */}
      <aside style={{ flex: '0 0 160px', minWidth: '160px' }}>
        <AdBanner />
      </aside>
    </main>
  );
};

const About = () => (
  <main className="raleway-content">
    <h1>About IntelliQ</h1>
    <p>We explore the intersection of psychology, intelligence, and behavior. Our content is designed for curious minds looking to understand how and why we think the way we do.</p>
  </main>
);

const Privacy = () => (
  <main className="raleway-content">
    <h1>Privacy Policy</h1>
    <p>We respect your privacy. This site may use cookies and third-party analytics tools to provide a better experience. No personal data is stored without consent.</p>
  </main>
);

const Contact = () => (
  <main className="raleway-content">
    <h1>Contact</h1>
    <p>For questions or feedback, email us at <a href="mailto:hello@intelliq.space">hello@intelliq.space</a></p>
  </main>
);

const App = () => (
  <Router>
    <PopCashTrigger />
    <header style={{ backgroundColor: '#000', color: '#fff', padding: '1rem 0', textAlign: 'center' }}>
      <h1 className="orbitron-logo" style={{ fontSize: '1.75rem', fontWeight: 600, margin: 0 }}>IntelliQ</h1>
      <nav style={{ marginTop: '0.75rem' }}>
        <Link to="/" style={{ color: '#fff', margin: '0 1rem' }}>Home</Link>
        <Link to="https://track.formalytix.com/click?campaign_id=2&placement_sub_id=whitelist" style={{ color: '#fff', margin: '0 1rem' }}>Posts</Link>
        <Link to="/about" style={{ color: '#fff', margin: '0 1rem' }}>About</Link>
        <Link to="/privacy" style={{ color: '#fff', margin: '0 1rem' }}>Privacy</Link>
        <Link to="/contact" style={{ color: '#fff', margin: '0 1rem' }}>Contact</Link>
      </nav>
    </header>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog/:postId" element={<BlogPost />} />
      <Route path="/opera" element={<OperaLanding />} />
      <Route path="/iqtest" element={<IframeStackerTrigger />} />
      <Route path="/new" element={<VideoLandingPage />} />
    </Routes>
    <footer style={{ display: 'none' }}>
      <Link to="/about">About</Link>
      <Link to="/privacy">Privacy</Link>
      <Link to="/contact">Contact</Link>
    </footer>
  </Router>
);

export default App;